import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/gift_card_definitions',
  component: Management,
  redirect: '/gift_card_definitions/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/gift_card_definitions/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listGiftCardDefinitions
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/gift_card_definitions/ListTable'),
          meta: {
            auth: Auth.listGiftCardDefinitions,
            tabName: 'all'
          }
        },
        {
          path: 'active',
          component: () => import('@/views/gift_card_definitions/ListTable'),
          meta: {
            auth: Auth.listGiftCardDefinitions,
            tabName: 'active'
          }
        },
        {
          path: 'pending',
          component: () => import('@/views/gift_card_definitions/ListTable'),
          meta: {
            auth: Auth.listGiftCardDefinitions,
            tabName: 'pending'
          }
        },
        {
          path: 'expired',
          component: () => import('@/views/gift_card_definitions/ListTable'),
          meta: {
            auth: Auth.listGiftCardDefinitions,
            tabName: 'expired'
          }
        },
        {
          path: 'disabled',
          component: () => import('@/views/gift_card_definitions/ListTable'),
          meta: {
            auth: Auth.listGiftCardDefinitions,
            tabName: 'disabled'
          }
        }
      ]
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/gift_card_definitions/New'),
      meta: {
        auth: Auth.createGiftCardDefinition
      }
    },
    // 编辑
    {
      path: ':id/edit',
      component: () => import('@/views/gift_card_definitions/Edit'),
      meta: {
        auth: Auth.updateGiftCardDefinition
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/gift_card_definitions/DetailLayout'),
      meta: {
        auth: Auth.showGiftCardDefinition
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/gift_card_definitions/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showGiftCardDefinition
          }
        },
        // 充电卡
        {
          path: 'charging_cards',
          component: () => import('@/views/gift_card_definitions/details/ChargingCards'),
          meta: {
            tabName: 'charging_cards', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.listChargingCardDefinitions
          }
        },
        // 优惠券
        {
          path: 'coupons',
          component: () => import('@/views/gift_card_definitions/details/Coupons'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.listCouponDefinitions
          }
        },
        // 兑换记录
        {
          path: 'redemption_records',
          component: () => import('@/views/gift_card_definitions/details/RedemptionRecord'),
          meta: {
            tabName: 'redemption_records', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.listGiftCards
          }
        }
      ]
    }
  ]
}
